@if(component){
<div class="w-12 p-t-10 p-b-10"
     [style.min-height]="reservedHeight">
    <div style="max-width: 1920px; overflow: hidden; margin-left: auto; margin-right: auto; width: 100%;">
        <div class="wrap">
            @if(client.isCms || !!visibleSections.length){
            <text-box [data]="component"
                      [textAlign]="'left'"></text-box>
            }
            @if(hasManySections){
            <div class="flex flex-middle m-t-8 m-t-10-x m-b-8 m-b-4-s m-b-10-x">
                @for (visibleSection of visibleSections; track $index) {
                <button type="button"
                        style="border-radius: 20px;"
                        [class.m-r-2]="!$last"
                        [class]="isVisible(visibleSection) ? 'bg-col-6' : 'b-a b-col-1'"
                        class="s1 col-1 p-a p-t-2 p-b-2"
                        (click)="selectSection(visibleSection)"
                        *iCms="'title' of visibleSection"></button>
                }
            </div>
            }

            <!-- contents -->
            @for (section of component.sections; track $index) {
            <div [hidden]="!isVisible(section)"
                 [class]="!hasManySections ? 'm-t-10-x m-t-8 m-t-4-s' : ''"
                 class="overflow-visible">
                <related-products [source]="getSource(section)"
                                  [limit]="section.limit || 8"
                                  [options]="getOptions(section)"
                                  (isPrinted)="onPrinted($event, $index)">
                </related-products>
            </div>
            }
        </div>
    </div>
</div>
}